import { render, staticRenderFns } from "./ShoppingCartStateroom.vue?vue&type=template&id=4fa4b728&scoped=true"
import script from "./ShoppingCartStateroom.vue?vue&type=script&lang=js"
export * from "./ShoppingCartStateroom.vue?vue&type=script&lang=js"
import style0 from "./ShoppingCartStateroom.vue?vue&type=style&index=0&id=4fa4b728&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa4b728",
  null
  
)

export default component.exports